module.exports = {
	"title": "Pointer events",
	"description": "This specification integrates various inputs from mice, touchscreens, and pens, making separate implementations no longer necessary and authoring for cross-device pointers easier. Not to be mistaken with the unrelated \"pointer-events\" CSS property.",
	"spec": "http://www.w3.org/TR/pointerevents/",
	"status": "rec",
	"links": [
		{
			"url": "http://blogs.msdn.com/b/ie/archive/2011/09/20/touch-input-for-ie10-and-metro-style-apps.aspx",
			"title": "Implementation of Pointer Events in IE10"
		},
		{
			"url": "http://blogs.msdn.com/b/eternalcoding/archive/2013/01/16/hand-js-a-polyfill-for-supporting-pointer-events-on-every-browser.aspx",
			"title": "Hand.js, the polyfill for browsers only supporting Touch Events"
		},
		{
			"url": "http://blogs.msdn.com/b/davrous/archive/2013/02/20/handling-touch-in-your-html5-apps-thanks-to-the-pointer-events-of-ie10-and-windows-8.aspx",
			"title": "Article & tutorial"
		},
		{
			"url": "http://deeptissuejs.com",
			"title": "Abstraction library for pointer events"
		},
		{
			"url": "https://github.com/jquery/PEP",
			"title": "PEP: Pointer Events Polyfill"
		}
	],
	"bugs": [],
	"categories": [
		"DOM",
		"JS API"
	],
	"stats": {
		"ie": {
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "a x #1",
			"11": "y",
			"5.5": "n"
		},
		"edge": {
			"12": "y",
			"13": "y",
			"14": "y"
		},
		"firefox": {
			"2": "n",
			"3": "n",
			"4": "n",
			"5": "n",
			"6": "p",
			"7": "p",
			"8": "p",
			"9": "p",
			"10": "p",
			"11": "p",
			"12": "p",
			"13": "p",
			"14": "p",
			"15": "p",
			"16": "p",
			"17": "p",
			"18": "p",
			"19": "p",
			"20": "p",
			"21": "p",
			"22": "p",
			"23": "p",
			"24": "p",
			"25": "p",
			"26": "p",
			"27": "p",
			"28": "p",
			"29": "p",
			"30": "p",
			"31": "p",
			"32": "p",
			"33": "p",
			"34": "p",
			"35": "p",
			"36": "p",
			"37": "p",
			"38": "p",
			"39": "p",
			"40": "p",
			"41": "p d #2",
			"42": "p d #2",
			"43": "p d #2",
			"44": "p d #2",
			"45": "p d #2",
			"46": "p d #2",
			"47": "p d #2",
			"48": "p d #2",
			"49": "p d #2",
			"50": "p d #2",
			"51": "a #2",
			"52": "a #2",
			"53": "a #2",
			"3.5": "n",
			"3.6": "n"
		},
		"chrome": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "n",
			"8": "n",
			"9": "n",
			"10": "n",
			"11": "n",
			"12": "n",
			"13": "n",
			"14": "n",
			"15": "n",
			"16": "n",
			"17": "n",
			"18": "n",
			"19": "n",
			"20": "n",
			"21": "n",
			"22": "p",
			"23": "p",
			"24": "p",
			"25": "p",
			"26": "p",
			"27": "p",
			"28": "p",
			"29": "p",
			"30": "p",
			"31": "p",
			"32": "p",
			"33": "p",
			"34": "p",
			"35": "p",
			"36": "p",
			"37": "p",
			"38": "p",
			"39": "p",
			"40": "p",
			"41": "p",
			"42": "p",
			"43": "p",
			"44": "p",
			"45": "p",
			"46": "p",
			"47": "p",
			"48": "p",
			"49": "p",
			"50": "p",
			"51": "p",
			"52": "p d #3",
			"53": "p d #3",
			"54": "p d #3",
			"55": "y",
			"56": "y",
			"57": "y"
		},
		"safari": {
			"4": "n",
			"5": "n",
			"6": "n",
			"7": "p",
			"8": "p",
			"9": "p",
			"10": "p",
			"3.1": "n",
			"3.2": "n",
			"5.1": "n",
			"6.1": "p",
			"7.1": "p",
			"9.1": "p",
			"TP": "p"
		},
		"opera": {
			"9": "n",
			"11": "n",
			"12": "n",
			"15": "p",
			"16": "p",
			"17": "p",
			"18": "p",
			"19": "p",
			"20": "p",
			"21": "p",
			"22": "p",
			"23": "p",
			"24": "p",
			"25": "p",
			"26": "p",
			"27": "p",
			"28": "p",
			"29": "p",
			"30": "p",
			"31": "p",
			"32": "p",
			"33": "p",
			"34": "p",
			"35": "p",
			"36": "p",
			"37": "p",
			"38": "p",
			"39": "p d #3",
			"40": "p d #3",
			"41": "p d #3",
			"42": "y",
			"43": "y",
			"9.5-9.6": "n",
			"10.0-10.1": "n",
			"10.5": "n",
			"10.6": "n",
			"11.1": "n",
			"11.5": "n",
			"11.6": "n",
			"12.1": "n"
		},
		"ios_saf": {
			"8": "p",
			"10": "p",
			"3.2": "p",
			"4.0-4.1": "p",
			"4.2-4.3": "p",
			"5.0-5.1": "p",
			"6.0-6.1": "p",
			"7.0-7.1": "p",
			"8.1-8.4": "p",
			"9.0-9.2": "p",
			"9.3": "p"
		},
		"op_mini": {
			"all": "n"
		},
		"android": {
			"3": "p",
			"4": "p",
			"53": "p",
			"2.1": "p",
			"2.2": "p",
			"2.3": "p",
			"4.1": "p",
			"4.2-4.3": "p",
			"4.4": "p",
			"4.4.3-4.4.4": "p"
		},
		"bb": {
			"7": "p",
			"10": "p"
		},
		"op_mob": {
			"10": "n",
			"11": "p",
			"12": "p",
			"37": "p",
			"11.1": "p",
			"11.5": "p",
			"12.1": "p"
		},
		"and_chr": {
			"53": "p d #3"
		},
		"and_ff": {
			"49": "p"
		},
		"ie_mob": {
			"10": "a x",
			"11": "y"
		},
		"and_uc": {
			"11": "p"
		},
		"samsung": {
			"4": "p"
		}
	},
	"notes": "Firefox, starting with version 28, provides the 'dom.w3c_pointer_events.enabled' flag to support this specification.",
	"notes_by_num": {
		"1": "Partial support in IE10 refers the lack of pointerenter and pointerleave events.",
		"2": "Firefox support is disabled by default and [only supports mouse input](https://hacks.mozilla.org/2015/08/pointer-events-now-in-firefox-nightly/). On Windows only, touch can be enabled with the `layers.async-pan-zoom.enabled` and `dom.w3c_touch_events.enabled` flags",
		"3": "Can be enabled with the `#enable-pointer-events` flag."
	},
	"usage_perc_y": 5.88,
	"usage_perc_a": 0.39,
	"ucprefix": false,
	"parent": "",
	"keywords": "pointerdown,pointermove,pointerup,pointercancel,pointerover,pointerout,pointerenter,pointerleave",
	"ie_id": "pointerevents",
	"chrome_id": "4504699138998272",
	"firefox_id": "pointer-events",
	"webkit_id": "",
	"shown": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/features-json/pointer.json
 ** module id = 448
 ** module chunks = 0
 **/